<template>
  <div class="yk-stu-manager-new-wrapper clearfix">
    <el-form
      label-width="180px"
      :rules="rules"
      ref="form"
      :model="form"
      class="change-user-password-form"
    >
      <el-form-item label="考务端地址" prop="KWDUrl">
        <el-input v-model="form.KWDUrl"></el-input>
      </el-form-item>
      <el-form-item label="考务端文档地址" prop="KWWDUrl">
        <el-input v-model="form.KWWDUrl"></el-input>
      </el-form-item>
      <el-form-item label="管理端地址" prop="GLDUrl">
        <el-input v-model="form.GLDUrl"></el-input>
      </el-form-item>
      <el-form-item label="管理端文档地址" prop="GLDWDUrl">
        <el-input v-model="form.GLDWDUrl"></el-input>
      </el-form-item>
      <el-form-item label="学生端地址" prop="XSDUrl">
        <el-input v-model="form.XSDUrl"></el-input>
      </el-form-item>
      <el-form-item label="学生端文档地址" prop="XSDWDUrl">
        <el-input v-model="form.XSDWDUrl"></el-input>
      </el-form-item>
      <el-form-item label="手持端地址" prop="SCDUrl">
        <el-input v-model="form.SCDUrl"></el-input>
      </el-form-item>
      <el-form-item label="手持端文档地址" prop="SCDWDUrl">
        <el-input v-model="form.SCDWDUrl"></el-input>
      </el-form-item>
      <el-form-item label="管理规范地址" prop="GLGFUrl">
        <el-input v-model="form.GLGFUrl"></el-input>
      </el-form-item>
      <el-form-item label="流程图地址" prop="LCTUrl">
        <el-input v-model="form.LCTUrl"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save('form')">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        Id: "",
        KWDUrl: "",
        KWWDUrl: "",
        GLDUrl: "",
        GLDWDUrl: "",
        XSDUrl: "",
        XSDWDUrl: "",
        SCDUrl: "",
        SCDWDUrl: "",
        GLGFUrl: "",
        LCTUrl: ""
      },
      rules: {
        // KWDUrl: [{ required: true, message: "请输入", trigger: "blur" }],
        // KWWDUrl: [{ required: true, message: "请输入", trigger: "blur" }],
        // GLDUrl: [{ required: true, message: "请输入", trigger: "blur" }],
        // GLDWDUrl: [{ required: true, message: "请输入", trigger: "blur" }],
        // XSDUrl: [{ required: true, message: "请输入", trigger: "blur" }],
        // XSDWDUrl: [{ required: true, message: "请输入", trigger: "blur" }],
        // SCDUrl: [{ required: true, message: "请输入", trigger: "blur" }],
        // SCDWDUrl: [{ required: true, message: "请输入", trigger: "blur" }],
        // GLGFUrl: [{ required: true, message: "请输入", trigger: "blur" }],
        // LCTUrl: [{ required: true, message: "请输入", trigger: "blur" }]
      }
    };
  },
  created() {
    this.getFileUrlList();
  },
  props:{
    certificateId: {
      type: String,
      default: ""
    }
  },
  methods: {
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var that = this;
          that.$http
            .post("/api/XOrg/FileManager/addOrEditFileUrl", {
              Id: that.form.Id,
              KWDUrl: that.form.KWDUrl,
              KWWDUrl: that.form.KWWDUrl,
              GLDUrl: that.form.GLDUrl,
              GLDWDUrl: that.form.GLDWDUrl,
              XSDUrl: that.form.XSDUrl,
              XSDWDUrl: that.form.XSDWDUrl,
              SCDUrl: that.form.SCDUrl,
              SCDWDUrl: that.form.SCDWDUrl,
              GLGFUrl: that.form.GLGFUrl,
              LCTUrl: that.form.LCTUrl,
              certificateId:this.certificateId
            })
            .then(function(rst) {
              if (rst.code > 0) {
                that.getFileUrlList();
                that.$message.success(rst.msg);
              } else {
                that.$message.warning(rst.msg);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //查询
    getFileUrlList() {
      var that = this;
      this.$http
        .post("/api/XOrg/FileManager/getFileUrlList",{
          certificateId:this.certificateId
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.form = rst.list;
          } else {
            that.$message.warning(rst.msg);
          }
        });
    }
  }
};
</script>

<style lang="scss">
.yk-stu-manager-new-wrapper {
  padding-top: 50px;
  .change-user-password-form {
    width: 50%;
  }
}
</style>